import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
export function PainPoints() {
  const problems = ['puertas minimalistas,', 'pérgolas premium,', 'escaleras modernas,', 'y portones automáticos…'];
  return <section className="py-7 md:py-12 px-3 bg-brand-dark" data-id="element-115">
      <div className="max-w-2xl mx-auto" data-id="element-116">
        <div className="flex justify-center mb-4" data-id="element-117">
          <div className="bg-red-500/10 border border-red-500 text-red-500 font-black px-4 py-1 rounded-full text-[10px] md:text-sm tracking-widest uppercase flex items-center" data-id="element-118">
            <AlertTriangle className="w-3.5 h-3.5 mr-1.5" data-id="element-119" />
            🔥 EL PROBLEMA
          </div>
        </div>

        <h2 className="text-lg md:text-3xl font-black text-center mb-4 text-white leading-tight uppercase" data-id="element-120">
          La mayoría de los herreros sigue haciendo siempre los mismos trabajos
          básicos.
        </h2>

        <p className="text-sm md:text-lg text-gray-300 mb-5 text-center max-w-xl mx-auto leading-relaxed" data-id="element-121">
          Puertas comunes, diseños viejos y estructuras que cada vez se cobran
          peor.
        </p>

        <div className="bg-brand-card border-l-4 border-brand-accent p-4 md:p-6 rounded-r-lg mb-5 shadow-lg" data-id="element-122">
          <p className="text-base md:text-xl font-black text-white mb-3" data-id="element-123">
            Mientras tanto, los trabajos modernos:
          </p>

          <ul className="space-y-2 mb-4" data-id="element-124">
            {problems.map((prob, idx) => <li key={idx} className="flex items-center text-sm md:text-lg font-bold text-brand-neon" data-id="element-125">
                <span className="mr-2 text-lg" data-id="element-126">👉</span> {prob}
              </li>)}
          </ul>

          <p className="text-sm md:text-lg text-white font-bold bg-brand-dark p-3 rounded-md border border-white/10" data-id="element-127">
            son los que más llaman la atención y{' '}
            <span className="text-brand-accent" data-id="element-128">
              mejores presupuestos generan.
            </span>
          </p>
        </div>

        <div className="text-center mb-6" data-id="element-129">
          <p className="text-base md:text-xl font-black text-red-500 bg-red-500/10 inline-block px-4 py-2 rounded-lg border border-red-500/30 leading-tight" data-id="element-130">
            El problema es que muy pocos tienen diseños modernos realmente
            listos para fabricar.
          </p>
        </div>

        <div className="w-full max-w-sm mx-auto text-center" data-id="element-131">
          <p className="text-gray-400 font-bold mb-2 text-[10px] md:text-xs uppercase tracking-wider" data-id="element-132">
            No te quedes atrás 👇
          </p>
          <Button onClick={scrollToCompra} className="py-3 text-sm md:text-base w-full" data-id="element-133">
            QUIERO ACTUALIZAR MIS DISEÑOS
          </Button>
        </div>
      </div>
    </section>;
}